import { Injectable } from '@angular/core';
import { Subject, Observable } from 'rxjs';
import { RideListItem } from '../../../shared/interfaces/ride-list-item';

@Injectable({
  providedIn: 'root'
})
export class RideUpdatesService {
  private activeRideId: string | null = null;
  private activeSubject: Subject<RideListItem> | null = null;

  /**
   * Registers a ride for updates. Only one ride can be active at a time.
   * This should be called when opening a dialog.
   */
  startTrackingRide(rideId: string): Observable<RideListItem> {
    // Clean up any previous active ride
    this.stopTracking();
    
    // Set up new tracking
    this.activeRideId = rideId;
    this.activeSubject = new Subject<RideListItem>();
    
    return this.activeSubject.asObservable();
  }

  /**
   * Emits an update for the currently tracked ride.
   * Only emits if the rideId matches the active ride.
   */
  emitRideUpdate(rideId: string, rideData: RideListItem): void {
    if (this.activeRideId === rideId && this.activeSubject) {
      this.activeSubject.next(rideData);
    }
  }

  /**
   * Stops tracking the current ride and cleans up resources.
   * Should be called when dialog closes.
   */
  stopTracking(): void {
    if (this.activeSubject) {
      this.activeSubject.complete();
      this.activeSubject = null;
    }
    this.activeRideId = null;
  }

  /**
   * Gets the currently tracked ride ID (useful for debugging)
   */
  getActiveRideId(): string | null {
    return this.activeRideId;
  }
}
